import * as React from 'react';
import { Link } from 'react-router-dom';

interface Props {
  register: () => void;
  isLogged?: boolean;
}

const InvestSafelyComponent: React.StatelessComponent<Props> = (props: Props) => (
  <div className="tab-content padding-40">
    <div className="row">
      <div className="col-sm-6">
        <p>
          <strong>Invierte directamente en el capital de la empresa de manera sindicada</strong>
        </p>
        <div className="gap-20"/>
        <p>
          A través de los tickets de 3.000€, adquieres participaciones directamente en la empresa en la que estás
          invirtiendo. La inversión se realizará de manera sindicada con el resto de inversores de The Crowd Angel que
          participen en la operación, a través un Contrato de Sindicación, que garantiza poder negociar unas mejores
          condiciones de inversión como grupo de inversores.
        </p>
      </div>
      <div className="col-sm-6 text-center">
        <img
          style={{width: '486px', height: '243px'}}
          alt="invierte capital"
          src="/img/05_invierte_capital.png"
        />
      </div>
    </div>
    <div className="gap-50"/>
    <div className="row">
      <div className="col-sm-6 text-center">
        <img
          style={{width: '400px', height: '200px'}}
          alt="contratos"
          src="/img/06_contratos.png"
        />
      </div>
      <div className="col-sm-6">
        <p>
          <strong>Contratos de inversión basados en los estándares del Capital Riesgo</strong>
        </p>
        <div className="gap-20"/>
        <p>
          Los contratos de inversión estandarizados con los que trabajamos, el Pacto de Socios y el Contrato de
          Sindicación, están elaborados en base a los estándares del Capital Riesgo y tienen como objetivo regular la
          relación entre Emprendedores, Inversores y Empresa; protegiendo los derechos de los inversores minoritarios.
        </p>
      </div>
    </div>
    <div className="gap-50"/>
    <div className="row">
      <div className="col-sm-6">
        <p>
          <strong>Due Diligence de las operaciones</strong>
        </p>
        <div className="gap-20"/>
        <p>
          Además de la evaluación de negocio que realizan nuestros analistas para cada operación, antes del desembolso
          de la inversión, encargamos a un tercero la elaboración de una Due Diligence financiera, legal, fiscal y
          laboral de cada compañía. Los inversores que hayáis comprometido al menos un ticket tendréis derecho a
          acceder a dicha Due Diligence antes de invertir.
        </p>
      </div>
      <div className="col-sm-6 text-center">
        <img
          style={{width: '320px', height: '160px'}}
          alt="due diligence"
          src="/img/07_duediligence.png"
        />
      </div>
    </div>
    <div className="gap-50"/>
    <div className="row">
      <div className="col-sm-6 text-center">
        <img
          style={{width: '560px', height: '260px'}}
          alt="pago seguro"
          src="/img/08_pago_seguro.png"
        />
      </div>
      <div className="col-sm-6">
        <p>
          <strong>Proceso de inversión online y pago seguro</strong>
        </p>
        <div className="gap-20"/>
        <p>
          Todo el proceso de inversión se realiza de manera 100% online, incluyendo las firmas de los contratos con la
          herramienta Signaturit. La gestión de los pagos de la inversión se realiza a través de Mangopay, una
          plataforma de pagos híbrida aprobada y regulada por el Banco de España, de esta forma mantenemos la
          transparencia en la gestión del dinero destinado a cada operación.
        </p>
      </div>
    </div>
    <div className="gap-50"/>
    <p className="text-center">
      {props.isLogged ?
        <Link to={'/invertir'}>
          <button className="btn btn-secondary btn-lg">
            Invertir
          </button>
        </Link> :
        <button
          className="btn btn-secondary btn-lg"
          onClick={() => props.register()}
        >
          Registrarse
        </button>
      }
    </p>
  </div>
);

export default InvestSafelyComponent;



// WEBPACK FOOTER //
// ./src/modules/how-to-invest/partials/InvestSafely.component.tsx